import React from 'react'
import { NavLink } from 'react-router-dom'
import './index.css'

const NewFooter = () => {

    const data = [
        {
            title: 'Contact',
            id: 1,
            content: [
                {
                    icon: "my-pin.jpg",
                    desc: "Longcroft House,<br> 2-8 victoria Avenue<br> London, EC2M 4NS",
                    isHTML: true,
                    alt: 'Address'
                },
                {
                    icon: "my-mail.jpg",
                    desc: '<a href="mailto:info@myprivatechemist.com">info@myprivatechemist.com</a>',
                    isHTML: true,
                    alt: 'Email Address'
                },
                {
                    icon: "my-phone.jpg",
                    desc: '<a href="tel:0203 987 9202">0203 987 9202</a>',
                    isHTML: true,
                    alt: 'Telephone'
                },
            ]
        },
        {
            title: 'Quick Links',
            id: 2,
            content: [
                // {
                //     path:'',
                //     desc:"Home"
                // },
                // {
                //     path:'',
                //     desc:"Our Mission"
                // },
                {
                    path: '/blood-testing',
                    desc: "Blood Testing"
                },
                {
                    path: '/build-my-package/',
                    desc: "Build My Package"
                },
                {
                    path: '/travel-clinic',
                    desc: "Travel Clinic"
                },
                // {
                //     path: '/transcription',
                //     desc: "Transcription"
                // },
                {
                    path: '/a-z-tests/',
                    desc: "A-Z Test"
                },
                {
                    path: '/contact',
                    desc: "Contact Us"
                },
                // {
                //     path: '/weight-loss/',
                //     desc: "Weight Loss"
                // },
                // {
                //     path:'',
                //     desc:"Treatment & Medication"
                // },
                // {
                //     path:'',
                //     desc:"Consultation"
                // },
                // {
                //     path:'',
                //     desc:"GP Services"
                // },
                // {
                //     path:'',
                //     desc:"Health Checks"
                // },
                // {
                //     path:'',
                //     desc:"Corporate"
                // },
                // {
                //     path:'',
                //     desc:"Sexual Health"
                // },
            ]
        },
        {
            title: 'Opening',
            id: 3,
            content: [
                {
                    desc: "Monday 9:00 - 17:00"
                },
                {
                    desc: "Tuesday 9:00 - 17:00"
                },
                {
                    desc: "Wednesday 9:00 - 17:00"
                },
                {
                    desc: "Thursday 9:00 - 17:00"
                },
                {
                    desc: "Friday Closed"
                },
                {
                    desc: "Saturday Closed"
                },
                {
                    desc: "Sunday Closed"
                },
            ]
        },
    ]

    const socialdata = [
        {
            title: 'Follow Us or Contact',
            content: [
                {
                    path: 'https://www.facebook.com/myprivatechemist',
                    img: 'my-fb.jpg',
                    alt: 'Facebook'
                },
                {
                    path: 'https://www.linkedin.com/company/my-private-chemist/?originalSubdomain=uk',
                    img: 'my-tw.png',
                    alt: 'Linkedin'
                },
                {
                    path: 'https://www.instagram.com/myprivatechemist/',
                    img: 'my-insta.jpg',
                    alt: 'Instagram'
                },
            ]
        },
        // {
        //     title: 'Payment Accepted',
        //     id: 2,
        //     content: [
        //         {
        //             path: '',
        //             img: 'my-visa.jpg'
        //         },
        //         {
        //             path: '',
        //             img: 'my-card.jpg'
        //         },
        //     ]
        // },

    ]
    const cardsdata = [
        {
            title: 'Payment Accepted',
            id: 2,
            content: [
                {
                    img: 'my-visa.jpg',
                    alt: 'Visa'
                },
                {
                    img: 'my-card.jpg',
                    alt: 'Card'
                },
            ]
        },

    ]
    return (
        <div className='footer-new'>
            <div className='container'>
                <div className='row g-3'>
                    {
                        data?.map((data, index) =>
                            <div className={data?.id === 2 ? 'col-xl-6 col-lg-4' : 'col-xl-3 col-lg-4'} key={index}>
                                <div className={
                                    data?.id === 2 ? 'mar-list' : null
                                }>
                                    <h4 className='fw-bold title footer-heads footer-title'>{data?.title}</h4>
                                    {
                                        data.id === 1 ? (
                                            data?.content?.map((cont, i) => (
                                                <div className="d-flex gap-3 align-items-start mb-1 justify-content-center justify-content-lg-start" key={i}>
                                                    <div className="flex-shrink-0 d-flex pt-0">
                                                        <img
                                                            src={`/assets/icons/${cont?.icon}`}
                                                            width={16}
                                                            alt={cont.alt}
                                                            className="img-fluid img-mails"
                                                        />
                                                    </div>
                                                    <p className="m-0 metropill desc desc-new" dangerouslySetInnerHTML={{ __html: cont?.desc }}></p>
                                                </div>
                                            ))
                                        )
                                            :
                                            data.id === 2 ? (
                                                <div className="list">
                                                    <ul>
                                                        {data?.content?.map((cont, i) => (
                                                            <li key={i}>
                                                                <NavLink to={cont?.path}>
                                                                    <div className="d-flex gap-10p align-items-start mb-1 justify-content-center justify-content-lg-start">
                                                                        <div className="flex-shrink-0 d-flex pt-0">
                                                                            <img
                                                                                src="/assets/icons/my-plus.png"
                                                                                width={16}
                                                                                alt="point"
                                                                                className="img-fluid"

                                                                            />
                                                                        </div>
                                                                        <p className="m-0 metropill desc link-new">{cont?.desc}</p>
                                                                    </div>
                                                                </NavLink>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <div>
                                                    {data?.content?.map((cont, i) => (
                                                        <p className="m-0 metropill desc desc-new text-center text-lg-end">{cont?.desc}</p>
                                                    ))}
                                                </div>
                                            )
                                    }
                                </div>
                            </div>
                        )
                    }

                </div>
                <div className='row'>
                    <div className='col-lg-4 col-xl-3 mt-auto mb-4'>
                        <div className='reg-area'>
                            <p className='metropill fs-14 mb-3'>
                                <strong className='metropills fw-bold'>Company: </strong>
                                MI Health Ltd
                            </p>
                            <p className='metropill fs-14 mb-3'>
                                <strong className='metropills fw-bold'>Premises GPhC Number: </strong>
                                9011648
                            </p>
                            <p className='metropill fs-14 mb-3'>
                                <strong className='metropills fw-bold'>Superintendent: </strong>
                                Imran Tailor (2216145)
                            </p>
                            <img src="/assets/icons/gen.png" width={146} className='img-fluid' alt="General Pharmaceutical Council" />
                        </div>
                    </div>
                    <div className='col-lg-4 col-xl-6 my-auto'>
                        <div className='d-flex justify-content-center'>
                            <NavLink to={''}>
                                <img src="/logo-footer.png" className='img-fluid logo-footer' width={180} height={87} alt="logo" />
                            </NavLink>
                        </div>
                    </div>
                    <div className='col-lg-4 col-xl-3 mt-4'>
                        {
                            socialdata?.map((social, i) =>
                                <div className='my-2 social-icons' key={i}>
                                    <h4 className='fw-bold title footer-title metropills'>
                                        {social?.title}
                                    </h4>
                                    <div className='d-flex align-items-center gap-3 justify-content-end py-2'>
                                        {
                                            social?.content?.map((listsocial, a) =>
                                                <NavLink to={listsocial?.path} key={a} target='_blank'>
                                                    <img src={'/assets/icons/' + listsocial?.img} width={social?.id === 2 ? 33 : 18} alt={listsocial.alt} />
                                                </NavLink>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }
                        {
                            cardsdata?.map((payment, i) =>
                                <div className='social-icons' key={i}>
                                    <h4 className='fw-bold title footer-title metropills'>
                                        {payment?.title}
                                    </h4>
                                    <div className='d-flex align-items-center gap-3 justify-content-end py-3'>
                                        {
                                            payment?.content?.map((listpayment) =>
                                                <span>
                                                    <img src={'/assets/icons/' + listpayment?.img} width={payment?.id === 2 ? 33 : 18} alt={listpayment.alt} />
                                                </span>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </div>
                <div className="row mb-10px">
                    <div className='col-lg-6'>
                        <div className='text-start'>
                            <p className='m-0 metropill copy-right-para'>
                                Copyright © by MPC 2026. All rights reserved.
                            </p>
                        </div>
                    </div>
                    <div className='col-lg-6 my-auto'>
                        <div className='text-end footer-links'>
                            <ul className='metropill d-flex justify-content-end align-items-center'>
                                <li> <a href='/contact' className='metropill' >About</a></li>
                                <li><NavLink className='metropill' to="/complaints">Complaints</NavLink></li>
                                <li><NavLink className='metropill' to="/cookie-policy">Cookie Policy</NavLink></li>
                                <li><NavLink className='metropill' to="/privacy-policy">Privacy Policy</NavLink></li>
                                <li><NavLink className='metropill' to="/terms-and-conditions">Terms and Conditions</NavLink></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { NewFooter };
export default NewFooter;